import styled from 'styled-components';
import { BACKGROUND_COLOR } from '../../../constants';
import { CloseButtonInModal } from '../../common/CloseButtonInModal';
import TransitioningModal from '../TransitioningModal';
import { useImageGenerationSettingsContext } from '../../../context/ImageGenerationSettingsProvider';
import { SpeedModeType } from '../../../types';
import { getEngineUsingModelId } from '../../../utils/engineHelpers';
import CustomRadioOption from './CustomRadioOption';

interface HomePageSettingsModalProps {
  show: boolean;
  setShow: (show: boolean) => void;
}

const HomePageSettingsModal = ({
  show,
  setShow,
}: HomePageSettingsModalProps) => {
  const { setSpeedMode, setEngine } = useImageGenerationSettingsContext();

  const handleClose = () => setShow(false);

  const handleModeChange = (mode: SpeedModeType, modelId: string) => {
    const engine = getEngineUsingModelId(modelId);
    setSpeedMode(mode);
    setEngine(engine);
    handleClose();
  };

  return (
    <Modal
      isOpen={show}
      style={{
        overlay: {
          backgroundColor: 'rgba(0, 0, 0, 0.5)',
          zIndex: 100,
        },
        content: {
          position: 'relative',
          backgroundColor: BACKGROUND_COLOR,
          padding: '16px',
          width: '90vw',
          maxWidth: '400px',
          height: 'auto',
          margin: 'auto',
          marginTop: '20vh',
        },
      }}
      ariaHideApp={false}
      shouldFocusAfterRender={false}
      onRequestClose={handleClose}
    >
      <ModalTitle>Generation Mode</ModalTitle>
      <CloseButtonInModal onClick={handleClose} />

      <SettingsSection>
        <RadioGroup>
          <CustomRadioOption
            name="generationMode"
            handleModeChange={handleModeChange}
            modelId="realistic_vision_v5.1"
            speedModeToSet="adTurbo"
            label="Realistic with ads (Free)"
            description="Realistic image generation with ads. Good for simpler designs."
            costs={false}
          />

          <CustomRadioOption
            name="generationMode"
            handleModeChange={handleModeChange}
            modelId="wai-nsfw-illustrious-sdxl"
            speedModeToSet="turbo"
            label="Hentai XL, costs 5x"
            description="Hentai images with excellent understanding"
            costs={true}
          />

          <CustomRadioOption
            name="generationMode"
            handleModeChange={handleModeChange}
            modelId="big-lust"
            speedModeToSet="turbo"
            label="Realistic XL, costs 5x"
            description="Realistic images - leans towards NSFW!"
            costs={true}
          />
        </RadioGroup>
      </SettingsSection>
    </Modal>
  );
};

const Modal = styled(TransitioningModal)`
  display: flex;
  flex-direction: column;
  z-index: 3;
`;

const ModalTitle = styled.h2`
  margin: 0 0 24px 0;
  text-align: center;
`;

const SettingsSection = styled.div`
  margin: 16px 0;
`;

const RadioGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

export default HomePageSettingsModal;
